import ThumbnailUploaderModal from "components/media/imageUploader/thumbnailUploaderModal/ThumbnailUploaderModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/pro-solid-svg-icons";
import { type FC, type ReactNode } from "react";
import cn from "classnames";

import "./thumbnailPreview.scss";

export interface Props {
  assetManifests: { type: string; url: string }[];
  sasLinkProviderAsync: () => Promise<{ uri: string; [key: string]: unknown }>;
  videosActions: { changeImageProcessingState: (processing: boolean) => void };
  entityId: number;
  generateThumbnail: (sas: { uri: string; [key: string]: unknown }) => void;
  textTracks: { kind: string; src: string }[];
  areTextTracksLoading: boolean;
  renderField: () => ReactNode;
  isReadOnly?: boolean;
  isReadOnlyView?: boolean;
}
const ThumbnailPreview: FC<Props> = (props) => {
  const {
    assetManifests,
    sasLinkProviderAsync,
    videosActions,
    entityId,
    generateThumbnail,
    textTracks,
    areTextTracksLoading,
    renderField,
    isReadOnly,
    isReadOnlyView,
  } = props;

  const renderPreview = (onClick: () => void) => (
    <div className={"edit-video-source-thumbnail"}>
      <span className={cn({ "required-asterisk": !isReadOnlyView, "read-only": isReadOnlyView })}>Video</span>
      {!isReadOnly && <FontAwesomeIcon icon={faPenToSquare} onClick={onClick} />}
    </div>
  );

  return (
    <ThumbnailUploaderModal
      trigger={renderPreview}
      assetManifests={assetManifests}
      sasLinkProviderAsync={sasLinkProviderAsync}
      videosActions={videosActions}
      entityId={entityId}
      generateThumbnail={generateThumbnail}
      textTracks={textTracks}
      areTextTracksLoading={areTextTracksLoading}
      renderField={renderField}
    />
  );
};

export default ThumbnailPreview;
